import { css } from '@emotion/core'
import PropTypes from 'prop-types'
import React from 'react'

const Bladr = ({ direction, action, display, className }) => (
  <aside
    onClick={action}
    css={css`
      position: absolute;
      ${direction === 'frem' ? 'right:0;' : 'left:0;'}
      z-index: ${display ? 'inherit' : -1};
      height: 100%;
      width: 2rem;
      background-color: black;
      opacity: 0.3  ;
      cursor: pointer;
      &:hover {
        opacity: 0.6;
        background-color: orchid;
      }
    `}
  >
    <span
      css={css`
        position: fixed;
        padding: 0.1rem;
        user-select: none;
        top: 47%;
        color: white;
        font-size: 2rem;
      `}
    >
      {direction === 'frem' ? '⥹' : '⥺'}
    </span>
  </aside>
)
Bladr.propTypes = {
  direction: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  display: PropTypes.bool.isRequired,
  className: PropTypes.string,
}
Bladr.defaultProps = {
  backgroundColor: 'black',
  color: 'white',
}

export default Bladr
